var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row m0 pb30 next-event-container"},[_c('cms-block',{staticClass:"container px30 next-event-block",attrs:{"identifier":'find-next-event'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }